import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { HttpModule } from '@angular/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';

import { routes, partialComponents } from './app-routing.module';

import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

import { AngularWebStorageModule } from 'angular-web-storage';

import { environment } from '../environments/environment';
import { HomeComponent } from './pages/home/home.component';

import {MatSidenavModule} from '@angular/material/sidenav';
import { HeaderComponent } from './pages/header/header.component';
import {MatSelectModule} from '@angular/material/select';
import {MatProgressBarModule} from '@angular/material/progress-bar';

import { ChartsModule } from 'ng2-charts';
import { UsersComponent } from './pages/users/users.component';
import { CompaniesComponent } from './pages/companies/companies.component';
import { ConfirmDeleteComponent } from './pages/partials/confirm-delete/confirm-delete.component';

import {MatDialogModule} from '@angular/material/dialog';
import { NewUserComponent } from './pages/new-user/new-user.component';
import { NewCompanyComponent } from './pages/new-company/new-company.component';
import {MatSortModule} from '@angular/material/sort';
import { EditUserComponent } from './pages/edit-user/edit-user.component';

import { TextMaskModule } from 'angular2-text-mask';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { DocumentsComponent } from './pages/documents/documents.component';
import { NewDocumentComponent } from './pages/new-document/new-document.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import {MatInputModule, MatButtonToggleModule, MatExpansionModule} from '@angular/material';
import { EditDocumentComponent } from './pages/edit-document/edit-document.component';
import { EditCompanyComponent } from './pages/edit-company/edit-company.component';

import { CurrencyMaskModule } from 'ng2-currency-mask';
import { SegmentsComponent } from './pages/segments/segments.component';
import { DocumentsTypeComponent } from './pages/documents-type/documents-type.component';
import { InputDataComponent } from './pages/partials/input-data/input-data.component';

import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { BiddingsComponent } from './pages/biddings/biddings.component';
import { NewBiddingsComponent } from './pages/new-biddings/new-biddings.component';
import { ActivitiesComponent } from './pages/activities/activities.component';
import { NewActivityComponent } from './pages/partials/new-activity/new-activity.component';
import { NewBiddingComponent } from './pages/partials/new-bidding/new-bidding.component';
import { BrCurrencyPipe } from './pipes/br-currency-pipe';
import { RejectBiddingComponent } from './pages/partials/reject-bidding/reject-bidding.component';
import { BiddingsReportComponent } from './pages/biddings-report/biddings-report.component';
import { ActivitiesReportComponent } from './pages/activities-report/activities-report.component';
import { PartnersComponent } from './pages/partners/partners.component';
import { NewPartnerComponent } from './pages/new-partner/new-partner.component';
import { EditPartnerComponent } from './pages/edit-partner/edit-partner.component';
import { PartnersReportComponent } from './pages/partners-report/partners-report.component';
import { CustomersReportComponent } from './pages/customers-report/customers-report.component';
import { IndicationsComponent } from './pages/indications/indications.component';
import { ConfirmCreateComponent } from './pages/partials/confirm-create/confirm-create.component';
import { FrequentQuestionsComponent } from './pages/partials/frequent-questions/frequent-questions.component';
import { SalesFunnelReportComponent } from './pages/sales-funnel-report/sales-funnel-report.component';
import { BudgetReportComponent } from './pages/budget-report/budget-report.component';
import { ExcelReportComponent } from './pages/excel-report/excel-report.component';

import { OrderModule } from 'ngx-order-pipe';
import { CompanyReportComponent } from './pages/company-report/company-report.component';

@NgModule({
  declarations: [
    AppComponent,
    ...partialComponents,
    HomeComponent,
    HeaderComponent,
    UsersComponent,
    CompaniesComponent,
    ConfirmDeleteComponent,
    NewUserComponent,
    NewCompanyComponent,
    EditUserComponent,
    ForgotPasswordComponent,
    ContactsComponent,
    DocumentsComponent,
    NewDocumentComponent,
    EditDocumentComponent,
    EditCompanyComponent,
    SegmentsComponent,
    DocumentsTypeComponent,
    InputDataComponent,
    BiddingsComponent,
    NewBiddingsComponent,
    ActivitiesComponent,
    NewActivityComponent,
    NewBiddingComponent,
    BrCurrencyPipe,
    RejectBiddingComponent,
    BiddingsReportComponent,
    ActivitiesReportComponent,
    PartnersComponent,
    NewPartnerComponent,
    EditPartnerComponent,
    PartnersReportComponent,
    CustomersReportComponent,
    IndicationsComponent,
    ConfirmCreateComponent,
    FrequentQuestionsComponent,
    SalesFunnelReportComponent,
    BudgetReportComponent,
    ExcelReportComponent,
    CompanyReportComponent
  ],
  imports: [
    OrderModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(routes),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    AngularWebStorageModule,
    MatSidenavModule,
    MatSelectModule,
    ChartsModule,
    MatProgressBarModule,
    MatDialogModule,
    MatSortModule,
    TextMaskModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatInputModule,
    CurrencyMaskModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatExpansionModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmDeleteComponent,
    InputDataComponent,
    NewActivityComponent,
    NewBiddingComponent,
    RejectBiddingComponent,
    ConfirmCreateComponent,
    FrequentQuestionsComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts